import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

import CircularProgress from '@mui/material/CircularProgress'
import { useTheme } from '@mui/material/styles'

import Footer from 'components/Footer'
import { useAPI } from 'hooks/useAPI'
import { useAuth } from 'hooks/useAuth'

export default function Container({ children }) {
  const { palette } = useTheme()
  const history = useHistory()
  const { initialized } = useAuth()
  const { requesting } = useAPI()

  // ページ遷移時に ScrollTop
  useEffect(() => {
    return history.listen(() => {
      window.scrollTo(0, 0)
    })
  }, [history])

  return (
    <div
      style={{
        flex: 1,
        background: palette.background.default,
      }}
    >
      <div style={{ width: '100%', maxWidth: 800, margin: '0 auto' }}>
        {initialized && children}
      </div>
      <Footer />
      {(!initialized || requesting) && (
        <div
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 2000,
          }}
        >
          <CircularProgress />
        </div>
      )}
    </div>
  )
}
